import React, { useContext } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { PriceRemoteContext } from 'Components/widgets/price-remote/PriceRemoteContext';
import { t } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { COLORS } from 'Components/utils/color/colors';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className?: string;
  handleClick: () => unknown;
  isCollapsed: boolean;
};
export const PriceRemoteDetailsToggle = ({ className, handleClick, isCollapsed }: Props) => {
  const [{ isJoyview }] = useContext(PriceRemoteContext);
  const color = isJoyview ? COLORS.BLUE_WAVE : COLORS.BLACK;
  const buttonLabel = t('priceRemote.openAllInclusiveDetails');
  return (
    <button
      className={classnames('flex items-center gap-5 text-14', `text-${color}`, className)}
      data-testid="strip-button"
      onClick={handleClick}
      type="button"
    >
      <Icon name={ICONS.ALL_INCLUSIVE} width="0.8125rem" />
      <span className="underline">{buttonLabel}</span>
      <Icon
        className="transition-transform ms-5 shrink-0 text-current duration-250 ease-in"
        name={ICONS.ARROW_DOWN}
        rotation={!isCollapsed ? 180 : 0}
        width="0.625rem"
      />
    </button>
  );
};
